// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26be5cda","455":"871453be","488":"e3499f53","977":"3bea03e5"}[chunkId] + ".chunk.js";
};